const MIN_PHONE_NUMBER_LENGTH = 10; // since preferredCountryCode defaults to US or CA

/**
 * @deprecated DS4 component — DS5 support is in progress. Do not add new usages.
 */
const getCleanNumber = (phoneNumber: string) => {
  return phoneNumber ? phoneNumber.replace(/\D/g, "") : "";
};

/**
 *
 * @deprecated Use `isValidPhoneNumberPerCountry` instead.
 */
const isValidPhoneNumber = (phoneNumber: string) => {
  return getCleanNumber(phoneNumber).length >= MIN_PHONE_NUMBER_LENGTH;
};

/**
 * @deprecated DS4 component — DS5 support is in progress. Do not add new usages.
 */
const isValidPhoneNumberPerCountry = (phoneNumber: string, minLengthPerCountry: number) => {
  return getCleanNumber(phoneNumber).length >= minLengthPerCountry;
};

export { isValidPhoneNumber, isValidPhoneNumberPerCountry, getCleanNumber };
